import React, { useContext, useEffect, useState } from 'react'
import back from "../dist/webImages/back.svg";
import { Field, Form, Formik, useField, useFormikContext } from 'formik';
import FormControl from '../components/form/FormControl';
import SubmitButton from '../components/SubmitButton';
import CKEditors from '../components/form/CKEditors';
import { Link, useNavigate, useParams } from 'react-router-dom';
import SkeletonCreateEdit from './SkeletonCreateEdit';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import useGet from '../customHooks/useGet';
import usePost2 from '../customHooks/usePost2';
import { MainLanguageContext } from '../context/MainLanguageContext';
import OneImageUpload from '../components/OneImageUpload';

const EditNews = ({ permission }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [resget, apiMethodGet] = useGet();
  const [datas, setDatas] = useState();
   const { mainLanguage } = useContext(MainLanguageContext);
  const [res, apiMethod] = usePost2();
  const newsTypeOptions = [
    "Car Rental Tips",
    "UAE Mobility",
    "Industry Insights",
    "Company Updates",
    "Sustainability",
    "Promotions & Offers",
  ];

  const SelectField = ({ name, label, options }) => {
    const [field, , helpers] = useField(name);
    const { errors, touched } = useFormikContext();
    return (
      <div className="inputBox w-full mt-3">
        {label && <label htmlFor={name} className="mb-1 block text-[#7D8CA7] text-[.8rem]">{label}</label>}
        <select
          id={name}
          className="outline-none w-full h-[3rem] px-5 rounded-xl border border-[#D1D5DB] bg-white"
          value={field.value}
          onChange={(e) => helpers.setValue(e.target.value)}
          onBlur={() => helpers.setTouched(true)}
        >
          <option value="">Select News Type</option>
          {options.map((option) => <option key={option} value={option}>{option}</option>)}
        </select>
        {touched[name] && errors[name] && <div className="my-1" style={{ color: "red" }}>{errors[name]}</div>}
      </div>
    );
  };

  useEffect(() => { apiMethodGet(`news/edit/${id}/${mainLanguage}`) }, [mainLanguage]);

  useEffect(() => {
    if (resget.data?.data) {
      setDatas(resget.data.data);
    }
  }, [resget.data]);

  const handleCkChange = (e, type) => setDatas(d => ({ ...d, [type]: e }));

  const handleSubmit = async (values) => {
    const requiredFields = ["meta_title", "meta_description", "news_title", "news_slug", "news_schedule"];
    const fieldLabels = {
      meta_title: "Meta title",
      meta_description: "Meta Description",
      news_title: "Title",
      news_slug: "slug",
      news_schedule: "Schedule",
    };
    const missingFields = requiredFields
      .filter((field) => !values[field])
      .map((field) => fieldLabels[field]);

    if (missingFields.length > 0) {
      swal({
        title: "Required Fields are empty! Please fill and try again",
        text: missingFields.join(","),
        icon: "error",
        dangerMode: true,
      });
      return;
    }

    const payload = {
      news_status: values.news_status?.length > 0 ? 1 : 0,
      news_schedule: values.news_schedule.replace("T", " "),
      news_slug: values.news_slug,
      news_image: datas?.news_value ?? "",
      table_of_content: values.table_of_content?.length > 0 ? 1 : 0,
      news_type: values.news_type,
      featured: values.featured?.length > 0 ? 1 : 0,
      translation: {
        meta_title: values.meta_title,
        meta_description: values.meta_description,
        news_title: values.news_title,
        news_short_paragraph: values.news_short_paragraph,
        news_paragraph: datas?.news_paragraph ?? "",
        author_name: values.author_name,
        author_description: datas?.author_description ?? "",
      }
    };
    apiMethod(`news/update/${id}/${mainLanguage}`, payload);
  };

  useEffect(() => {
    if (res.data) {
      const { status, message } = res.data;
      if (status === "false") toast.error(message);
      else {
        toast.success(message);
        navigate("/news");
      }
    }
  }, [res.data]);

  if (resget.isLoading || !datas) return <SkeletonCreateEdit heading={"Edit News"} />;

  const initialValues = {
    meta_title: resget.data.data.meta_title ?? "",
    meta_description: resget.data.data.meta_description ?? "",
    news_status: resget.data.data.news_status && [`${String(resget.data.data.news_status)}`],
    news_schedule: resget.data.data.news_schedule?.replace(" ", "T"),
    news_slug: resget.data.data.news_slug,
    news_type: resget.data.data.news_type,
    featured: resget.data.data.featured && [`${String(resget.data.data.featured)}`],
    table_of_content: resget.data.data.table_of_content && [`${String(resget.data.data.table_of_content)}`],
    news_title: resget.data.data.news_title,
    news_short_paragraph: resget.data.data.news_short_paragraph,
    news_paragraph: resget.data.data.news_paragraph,
    author_name: resget.data.data.author_name ?? "",
  };

  const check = (module, action) => permission?.[module]?.includes(action);
  return (
    <div className='newscreate pr-10 max-lg:pr-6'>
      <Link to={"/news"} className="back flex items-center mb-6 gap-2">
        <img src={back} className='w-[2rem]' alt="" />
        <span className='text-[1.4rem] font-MluvkaBold'>Edit News</span>
      </Link>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        <Form name="myForm">
          <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-3 max-lg:p-3'>
            <div className="grid grid-cols-2 gap-2">
              {
                mainLanguage === "en" ?
                  <FormControl disable name="news_slug" label={"Slug"} placeholder="Enter Slug" className="outline-none w-full h-[3rem] px-5 rounded-xl border border-[red]" control="input2" />
                  :
                  <div className='inputBox w-full mt-3'>
                    <label htmlFor="Schedule" className="mb-1 block text-[#7D8CA7] text-[.8rem]">Slug</label>
                    <p className="outline-none bg-[#e7e7e7] w-full h-[3rem] px-5 rounded-xl py-3">{datas?.news_slug}</p>
                  </div>

              }
              <SelectField name="news_type" label="News Type" options={newsTypeOptions} />
            </div>
            <FormControl name="meta_title" label={"Meta Title"} placeholder="Enter Meta Title" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
            <FormControl name="meta_description" label={"Meta Description"} placeholder="Enter Meta Description" className="outline-none w-full h-[10rem] px-5 py-3 rounded-xl resize-none" control="textarea2" />
          </div>
          <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-3'>
            <div className="h4 text-[#7D8CA7] text-[1.1rem] ">News</div>
            <FormControl name="news_title" label={"Title {h1}"} placeholder="Enter Title" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
            <FormControl name="news_short_paragraph" label={"Short Paragraph"} placeholder="Enter Short Paragraph" className="outline-none w-full h-[6rem] px-5 py-3 rounded-xl resize-none" control="textarea2" />
            <div className="mt-4 text-[#7D8CA7] text-[1.1rem]">Author Profile</div>
            <FormControl name="author_name" label="Author Name" placeholder="Enter Author Name" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
            <CKEditors label="Author Description" folder_name="news" page_type="news" data={datas?.author_description} update={(text) => handleCkChange(text, "author_description")} />
            <div className="mb-1 block text-[#7D8CA7] text-[.8rem]">Main Paragraph</div>
            <CKEditors label={"Main Paragraph"} folder_name={"news"} page_type={"news"} data={datas?.news_paragraph} update={(text) => handleCkChange(text, "news_paragraph")} />
            <OneImageUpload changeImage={() => {}} MainImage={datas?.news_image} Update={setDatas} sec_value="news_value" sec_image="news_image" folder_name="news" page_type="news" />
            <div className='relative'>
              <FormControl name="news_schedule" label={"Schedule"} type={'datetime-local'} placeholder="Enter Schedule" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
            </div>
            <div className="overflow-hidden relative pt-7 px-4">
              <label className="inline-flex items-center cursor-pointer">
                <Field value="1" type="checkbox" name="news_status" className="sr-only peer" />
                <div className="relative bg-[#1c1c1c] w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#401a89]"></div>
                <span className="ms-3 text-sm font-medium text-gray-900">News Status</span>
              </label>
            </div>
            <div className="overflow-hidden relative pt-7 px-4">
              <label className="inline-flex items-center cursor-pointer">
                <Field value="1" type="checkbox" name="table_of_content" className="sr-only peer" />
                <div className="relative bg-[#1c1c1c] w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#401a89]"></div>
                <span className="ms-3 text-sm font-medium text-gray-900">Table of Content</span>
              </label>
            </div>
            <div className="overflow-hidden relative pt-7 px-4">
              <label className="inline-flex items-center cursor-pointer">
                <Field value="1" type="checkbox" name="featured" className="sr-only peer" />
                <div className="relative bg-[#1c1c1c] w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#401a89]"></div>
                <span className="ms-3 text-sm font-medium text-gray-900">Featured</span>
              </label>
            </div>
          </div>
          {check("News", "News Edit") && <SubmitButton props={{ class: "btn bg-secondary text-white px-12 ml-auto uppercase mb-3 py-3 rounded-full w-100 block mt-5 submit hover:bg-primary transition-all duration-300", text: "Submit" }} buttonLoading={res.isLoading} />}
        </Form>
      </Formik>
    </div>
  )
}

export default EditNews
